import { adminHttpClient } from '../../../../commons/adminHttpClinet';
import { AddNewMarketplaceModel } from './../../../../models/dashboard/marketplace/affiliatesModel';

const addNewAffiliate = (model: AddNewMarketplaceModel) => {
    return adminHttpClient.post("/api/Admin/AdminMarketplace/add-marketplace", model);
};
export  default addNewAffiliate;